import React, { FC, HTMLAttributes } from 'react';
import classNames from 'classnames';
import styles from './InfiniteScrollLoader.module.scss';

const InfiniteScrollLoader: FC<HTMLAttributes<HTMLDivElement>> = (props: any) => {
  const rootClassName = classNames(styles.infiniteScrollLoader);

  return (
    <div className={rootClassName}>
      <i className='fas fa-spinner' />
    </div>
  );
};

export default InfiniteScrollLoader;
